// extracted by mini-css-extract-plugin
export default {"sobre":"paragrafo_sobre__eoRa7","sobre__texto":"paragrafo_sobre__texto__ebSjE"};